export default {
  path: '/top-sellers',
  name: 'top-sellers',
  meta: {
    title: 'eRank — Top Sellers on Etsy',
    requiresAuth: false,
    metaTags: [
      {
        content: 'Discover top-performing Etsy shops and unlock valuable insights to enhance your own success.',
        name: 'description',
      },
      {
        page_slug: 'top-sellers',
      },
    ],
  },
  component: () => import('@/modules/competitors/pages/top-sellers/Entry.vue'),
  children: [
    {
      path: '',
      name: 'top-sellers.index',
      component: () => import('@/modules/competitors/pages/top-sellers/AllTime.vue'),
    },
    {
      path: 'yesterday',
      name: 'top-sellers.yesterday',
      component: () => import('@/modules/competitors/pages/top-sellers/AllTime.vue'),
    },
  ],
};
